import {legacy_createStore as createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';

import {logger} from './logger';

const __CLIENT__ = typeof window !== 'undefined';
const composeEnhancers = (__CLIENT__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
const middlewares = [thunk.withExtraArgument({logger})];

export const __RESERVED_GLOBAL_REDUCER__ = '*';

export const __RESERVED_GLOBAL_NAMESPACE__ = '*';

export function createStoreFrom(initState = {}, mwares = middlewares) {
  const reducerRegistry = {
    [__RESERVED_GLOBAL_REDUCER__]: [],
  };

  const store = createStore(
    (state, action) => {
      state = state || /* istanbul ignore next */ {};
      const {type} = action;
      const reducers = (reducerRegistry[type] || []).concat(reducerRegistry[__RESERVED_GLOBAL_REDUCER__]);
      const values = reducers.map((func) => {
        return func(state, action);
      });

      return Object.assign({}, state, ...values);
    },
    initState,
    composeEnhancers(applyMiddleware(...mwares))
  );

  Object.defineProperties(store, {
    reducerRegistry: {
      enumerable: false,
      value: reducerRegistry,
    },
    registerReducer: {
      enumerable: false,
      value: (type, func) => {
        const typeReducers = reducerRegistry[type] || [];

        /* istanbul ignore else */
        if (typeof func !== 'function') {
          throw new TypeError(`reducer for action ${type} should be function`);
        }
        /* istanbul ignore else */
        if (typeReducers.indexOf(func) === -1) {
          typeReducers.push(func);
        }

        reducerRegistry[type] = typeReducers;
      },
    },

    unregisterReducer: {
      enumerable: false,
      value: (type, func) => {
        reducerRegistry[type] = (reducerRegistry[type] || []).filter((handler) => handler !== func);
      },
    },
  });

  return store;
}

export const store = createStoreFrom();
